import {SHOW_SPINNER, HIDE_SPINNER} from '../actions/SpinnerAction'
const initialState ={
    show: false,    
}

const ToasterReducer = (state = initialState, action) => {
    switch(action.type){
        case SHOW_SPINNER:
            return {...state, show: true}
        case HIDE_SPINNER:
            return {...state, show: false}
        default:
            return {...state}
    }
}

export default ToasterReducer;
